import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

// TODO [2024-05-01]: rgba(255, 244, 230, 1) add this color to theme library
export const StyledWarnBoxContainer = styled.div<{ isDarkMode?: boolean }>`
  padding: 1.6rem;
  background-color: ${({ isDarkMode }) => (isDarkMode ? 'rgba(255, 138, 0, 0.1)' : 'rgba(255, 244, 230, 1)')};
  display: flex;
  align-items: flex-start;
  gap: 1.4rem;
  border-radius: ${({ theme }) => theme.radius.small};
  border: 0.1rem solid ${({ theme }) => theme.colors.warning.light};
`;

export const StyledWarningIcon = styled(FontAwesomeIcon)`
  & {
    height: 2rem;
    width: 2rem;
    color: ${({ theme }) => theme.colors.warning.light};
  }
`;

export const StyledWarnText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
`;
